import { Pipe, PipeTransform } from '@angular/core'

import { getMarkupFromMarkdown } from '@flowx/core-sdk'

@Pipe({
  name: 'flxMarkdown',
  standalone: true,
})
export class FlxMarkdownPipe implements PipeTransform {
  transform(value: string, disabled = false): string {
    return getMarkupFromMarkdown(value, disabled)
  }
}
